import type { PublicUser, SetupStatus } from "@confluence/shared";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiFailure, get } from "./api";

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return (await get<{ user: PublicUser }>("/api/me")).user;
      } catch (err) {
        if (err instanceof ApiFailure && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });
}

export function useSetupStatus() {
  return useQuery({ queryKey: ["setup-status"], queryFn: () => get<SetupStatus>("/api/setup/status") });
}

/** Met à jour l'utilisateur connecté dans le cache après une connexion ou une modification. */
export function useSetMe() {
  const qc = useQueryClient();
  return (user: PublicUser | null) => qc.setQueryData(["me"], user);
}
